import Accordion from 'react-bootstrap/Accordion';
import Container from 'react-bootstrap/Container';
import { FaRobot, FaLock, FaMoneyBillWave, FaWhatsapp, FaUsers, FaCogs, FaInfoCircle } from 'react-icons/fa';

function PreguntasFrecuentes() {
  return (
    <div style={faqBackground}>
      <Container className="mt-4 mb-2">

        <h2
          className="text-center fw-bold"
          style={{ fontSize: "42px", color: "#FF7A00", marginTop: "30px", marginBottom: "5px" }}
        >
          Preguntas Frecuentes
        </h2>

        <p
          className="text-center text-primary"
          style={{ fontSize: "20px", marginBottom: "30px", maxWidth: "800px", marginInline: "auto" }}
        >
          Respondemos las dudas más comunes. Si tenés alguna otra consulta, ¡no dudes en escribirnos!
        </p>

        {/* 📦 Caja grande que contiene todo el acordeón */}
        <div style={boxGrande}>
          <Accordion flush>
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <FaInfoCircle style={iconStyle} />
                <span style={questionStyle}>¿Qué es IMAGINA Soluciones IT?</span>
              </Accordion.Header>
              <Accordion.Body style={answerStyle}>
                Somos una empresa que nació con una idea simple: ayudarte a trabajar mejor.
                En Imagina Soluciones IT creamos herramientas tecnológicas pensadas para hacerte la vida más fácil,
                especialmente si tenés un consultorio, clínica o centro de salud. Sabemos que el tiempo vale oro,
                por eso desarrollamos soluciones que te ahorran trabajo sin perder el toque humano.
              </Accordion.Body>
            </Accordion.Item>


            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <FaRobot style={iconStyle} />
                <span style={questionStyle}>¿Y de qué se trata Imagy? ¿Qué es eso?</span>
              </Accordion.Header>
              <Accordion.Body style={answerStyle}>
                Imagy es nuestro asistente virtual. Un bot simpático, eficiente y siempre listo para dar una mano.
                Automatiza turnos, responde preguntas frecuentes y recuerda citas por WhatsApp. Está disponible 24/7.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2">
              <Accordion.Header>
                <FaUsers style={iconStyle} />
                <span style={questionStyle}>¿Imagy reemplaza a mi equipo de trabajo?</span>
              </Accordion.Header>
              <Accordion.Body style={answerStyle}>
                Para nada. Imagy reemplaza tareas repetitivas, no personas. Ayuda a tu equipo a enfocarse en brindar una atención cercana y humana.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3">
              <Accordion.Header>
                <FaWhatsapp style={iconStyle} />
                <span style={questionStyle}>¿Cómo interactúan los pacientes con Imagy?</span>
              </Accordion.Header>
              <Accordion.Body style={answerStyle}>
                Escriben al número de WhatsApp del consultorio. Imagy los guía paso a paso para pedir turnos, consultar o recibir recordatorios.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="4">
              <Accordion.Header>
                <FaCogs style={iconStyle} />
                <span style={questionStyle}>¿Puedo personalizar los horarios y especialidades?</span>
              </Accordion.Header>
              <Accordion.Body style={answerStyle}>
                Sí. Desde un panel podés cargar médicos, especialidades y horarios. Imagy se adapta según lo que configures.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="5">
              <Accordion.Header>
                <FaLock style={iconStyle} />
                <span style={questionStyle}>¿Es seguro?</span>
              </Accordion.Header>
              <Accordion.Body style={answerStyle}>
                Totalmente. Usamos sistemas de encriptación y servidores seguros para proteger tu información.
                Solo personas autorizadas acceden a los datos.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="6">
              <Accordion.Header>
                <FaMoneyBillWave style={iconStyle} />
                <span style={questionStyle}>¿Cuánto cuesta el servicio?</span>
              </Accordion.Header>
              <Accordion.Body style={answerStyle}>
                Las nuevas cuentas prueban Imagy gratis durante 1 mes, con página de reservas, agenda y notificaciones por email, pero sin recordatorios por WhatsApp. Después pueden continuar con Imagy Premium por $15.000 ARS al mes, que sí incluye recordatorios automáticos por WhatsApp.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="7">
              <Accordion.Header>
                <FaCogs style={iconStyle} />
                <span style={questionStyle}>¿Necesito instalar algo?</span>
              </Accordion.Header>
              <Accordion.Body style={answerStyle}>
                No, IMAGINA funciona 100% en la nube. Solo necesitás internet y navegador. Podés acceder desde cualquier dispositivo. Aunque para tu comodidad podes instalar Imagy para Android.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>

      </Container>
    </div>
  );
}

const faqBackground = {
  background: 'linear-gradient(to bottom, #fff6e5, #fff1cc, #ffe5b4)',
  minHeight: '60vh',
  paddingTop: '20px',
  paddingBottom: '10px'
};

const boxGrande = {
  backgroundColor: "#ffffff",
  borderRadius: "20px",
  padding: "20px",
  border: "2px solid #fba801",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)"
};

const iconStyle = {
  marginRight: "12px",
  color: "#fba801",
  fontSize: "20px"
};

const questionStyle = {
  fontSize: "22px"
};

const answerStyle = {
  fontSize: "18px",
  lineHeight: "1.6"
};

export default PreguntasFrecuentes;
